import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { initLenis } from "@/lib/lenis";
import { getContent } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/lib/site";
import Admin from "@/pages/Admin";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import FeaturedEvent from "@/components/FeaturedEvent";
import Highlights from "@/components/Highlights";
import Categories from "@/components/Categories";
import WhyUs from "@/components/WhyUs";
import Accolades from "@/components/Accolades";
import Events from "@/components/Events";
import Gallery from "@/components/Gallery";
import Industry from "@/components/Industry";
import Sponsors from "@/components/Sponsors";
import Register from "@/components/Register";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

function MainSite() {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    initLenis();
    getContent().then(setContent).catch(() => {});
  }, []);

  return (
    <div className="grain bg-royal-950 min-h-screen text-cream" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About stats={content.stats} />
        <FeaturedEvent />
        <Highlights />
        <Categories />
        <WhyUs />
        <Accolades />
        <Events events={content.events} />
        <Gallery items={content.gallery} />
        <Industry />
        <Sponsors />
        <Register events={content.events} />
        <Testimonials items={content.testimonials} />
        <Contact />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainSite />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster position="top-center" theme="dark" />
    </BrowserRouter>
  );
}

export default App;
